import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img1 from "./img/img1.png";

export const PeopleChosen = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = () => {
    onNextStep();
    onTrackEvent();
  };

  return (
    <div className={styles.container} id="breakdown">
      <div className={styles.title}>
        <h1>4,280,000+</h1>
        <br />
        <p>users have chosen us</p>
      </div>
      <div className={styles.image}>
        <img src={img1} alt="bg" />
      </div>
      <div className={styles.action}>
        <Button variant='walky' onClick={handleNextStep}>Continue</Button>
      </div>
    </div>
  );
};
